module.exports = global["$"] = require("-!/home/jenkins/agent/workspace/dev_and_qa/lumapps-front/node_modules/expose-loader/index.js?jQuery!./jquery.js");